// extracted by mini-css-extract-plugin
export default {"container":"container--i3gxY","header":"header--fLXHL","footer":"footer--iBuTA","body":"body--dm_K7","walletDocker":"walletDocker--NKu4I"};